import { USER_MEMBERSHIP_STATUS } from '@shared/enums/membership';
import { MembershipTransaction } from '../../services/payment.model';

// Bug F3 fix: a pending confirmTransaction() call is persisted here so it survives a page
// refresh/crash and can be resent on the next app bootstrap (see AppComponent) instead of the
// confirmation being lost forever after a successful PayPal capture.
export const PENDING_PAYPAL_CONFIRM_STORAGE_KEY = 'pendingPaypalConfirm';

export interface PaypalOrderData {
  // The data you might need (e.g., payer information, shipping address, etc.)
}

export interface PaypalActions {
  order: {
    create: (orderDetails: any) => Promise<string>;
    capture: () => Promise<any>;
    get: (orderID: string) => Promise<any>;
  };
}

export interface PaypalApprovedOrderData {
  billingToken?: any;
  facilitatorAccessToken: string;
  orderID: string;
  payerID: string;
  paymentID: string;
  paymentSource: string;
}

export interface PaypalCapturedTransactionDetails {
  create_time: string;
  id: string;
  intent: string;
  links?: any[];
  payer: {
    name?: any;
    email_address: string;
    payer_id: string;
    address: any;
  }[];
  purchase_units?: any[];
  status: string;
  update_time: string;
}

export function isRenew(option: string = '', status: USER_MEMBERSHIP_STATUS): boolean {
  return option === 'RENEWAL' || (option === 'NEXT_PERIOD' && status > 2);
}

export function isEffectiveImmediately(option: string = ''): boolean {
  return option === 'EFFECTIVE_IMMEDIATELY';
}

export function isMemberTypeChanged(option: string = '', status: USER_MEMBERSHIP_STATUS): boolean {
  return option !== 'RENEWAL' && status > 2 && (option === 'EFFECTIVE_IMMEDIATELY' || option === 'NEXT_PERIOD');
}

export function getMembershipParams(item: MembershipTransaction, free: boolean = false, paymentModeId?: number) {
  // item.amount is the final, fee-inclusive charge (basePrice, prorated if applicable, plus any
  // Fee Offset the buyer opted into - see FeeOffsetComponent). totalPrice/totalDiscount are
  // derived from it so amount = totalPrice - totalDiscount + fee holds, same as the Event flow.
  const amount = free ? 0 : item.amount;
  const fee = free ? 0 : item.fee ?? 0;
  const totalPrice = free ? 0 : item.basePrice ?? item.amount;
  const totalDiscount = free ? 0 : totalPrice - amount + fee;

  return {
    userId: item.userId,
    totalDiscount,
    totalPrice,
    fee,
    memberShipId: item.membershipId,
    amount,
    isRenew: isRenew(item.period, item.currentMemberStatus),
    isAdminTransaction: false,
    paymentModeId: paymentModeId ?? 1,
    isEffectiveImmediately: item.period === 'EFFECTIVE_IMMEDIATELY',
    isMemberTypeChange: !!(item?.currentMembershipId && item?.currentMembershipId !== item.membershipId),
    notes: '',
  };
}
